// declare type ECS = typeof import('@my-account/ecs-logger');

import { ECS } from '@my-account/ecs-logger';

const logBaseFields: ECS = {
  service: {
    name: 'product-fe',
    environment: process.env && process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'local',
  },
};

export default logBaseFields;
